// Import JavaScript libraries
import '@hotwired/turbo-rails';
import { Application } from '@hotwired/stimulus';

// Import styles
import '../../assets/stylesheets/application.scss';

// Disable Turbo prefetching on hover
import { Turbo } from '@hotwired/turbo-rails';
Turbo.session.drive = true;
Turbo.config.drive.progressBarDelay = 0;
document.documentElement.setAttribute('data-turbo-prefetch', 'false');

// Import common dependencies
import { Modal, initializeBootstrapComponents, initializeTurboLoad } from './common';
import { initializeSidebarCollapsedTooltips } from '../utils/sidebar_collapsed_tooltips';
import { initializeNavInstantSkeleton } from '../utils/nav_instant_skeleton';
import { initializeLandingClickFeedback } from '../utils/landing_click_feedback';
import { initializeSkeletonHandoff } from '../utils/skeleton_handoff';
import { initializeIndexScopeSkeleton } from '../utils/index_scope_skeleton';
import { initializeIndexPaginationSkeleton } from '../utils/index_pagination_skeleton';
import { initializeRecentActivitySkeleton } from '../utils/recent_activity_skeleton';
import { initializeValueChangeMotion } from '../utils/value_change_motion';
import { initializeIndexRowLeave } from '../utils/index_row_leave';
import { initializeWorkflowStepSkeleton } from '../utils/workflow_step_skeleton';
import { initializeCreateSubmitTransition } from '../utils/create_submit_transition';
import { initializeMasqueradeVortex } from '../utils/masquerade_vortex';
import { initializeAuthVortex } from '../utils/auth_vortex';
import { initializeSignOutTransition } from '../utils/sign_out_transition';
import { initializeWorkflowStepNavCollapsedTooltips } from '../utils/workflow_step_nav_collapsed_tooltips';
import { startOsThemeObserver } from '../utils/theme_transition';
import { startThemeColorSync } from '../utils/theme_color';

// Create and export Stimulus application
const application = Application.start();

// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;

// Custom Turbo Stream Actions - registered immediately so they're available before any stream response
initializeTurboLoad();
initializeSidebarCollapsedTooltips();
initializeNavInstantSkeleton();
initializeLandingClickFeedback();
initializeSkeletonHandoff();
initializeIndexScopeSkeleton();
initializeIndexPaginationSkeleton();
initializeRecentActivitySkeleton();
initializeValueChangeMotion();
initializeIndexRowLeave();
initializeWorkflowStepSkeleton();
initializeCreateSubmitTransition();
initializeMasqueradeVortex();
initializeAuthVortex();
initializeSignOutTransition();
initializeWorkflowStepNavCollapsedTooltips();
startOsThemeObserver();
startThemeColorSync();

// Auto-load all Stimulus controllers
const controllers = import.meta.glob('../controllers/**/*_controller.{js,ts}', { eager: true });
for (const path in controllers) {
  const module = controllers[path] as any;
  if (module.default) {
    const name = path
      .replace('../controllers/', '')
      .replace(/_controller\.(js|ts)$/, '')
      .replace(/_/g, '-')
      .replace(/\//g, '--');
    application.register(name, module.default);
  }
}

// Initialize Bootstrap components
document.addEventListener('turbo:load', () => {
  initializeBootstrapComponents();
});